import * as Modules from 'src/modules/constants';
import { getPhoneCallDetails } from 'src/modules/details360/selector';
import { setNotification } from 'src/modules/details360/slice';
import { getState, store } from 'src/store';
import { renderModule } from '../slice';
import { getDecryptedEnvValue, parseJSON } from '../utils';

export const checkIfFCMKeysPresent = () =>
  !!getDecryptedEnvValue('FCM_API_KEY');

export const getFCMConfig = () =>
  process.env.NODE_ENV === 'production'
    ? {
        apiKey: getDecryptedEnvValue('PROD_FCM_API_KEY'),
        authDomain: getDecryptedEnvValue('PROD_FCM_AUTH_DOMAIN'),
        databaseURL: getDecryptedEnvValue('PROD_FCM_DATABASE_URL'),
        projectId: getDecryptedEnvValue('PROD_FCM_PROJECT_ID'),
        storageBucket: getDecryptedEnvValue('PROD_FCM_STORAGE_BUCKET'),
        messagingSenderId: getDecryptedEnvValue('PROD_FCM_SENDER_ID'),
        appId: getDecryptedEnvValue('PROD_FCM_APP_ID'),
        measurementId: getDecryptedEnvValue('PROD_FCM_MEASUREMENT_ID'),
      }
    : {
        apiKey: getDecryptedEnvValue('FCM_API_KEY'),
        authDomain: getDecryptedEnvValue('FCM_AUTH_DOMAIN'),
        databaseURL: getDecryptedEnvValue('FCM_DATABASE_URL'),
        projectId: getDecryptedEnvValue('FCM_PROJECT_ID'),
        storageBucket: getDecryptedEnvValue('FCM_STORAGE_BUCKET'),
        messagingSenderId: getDecryptedEnvValue('FCM_SENDER_ID'),
        appId: getDecryptedEnvValue('FCM_APP_ID'),
        measurementId: getDecryptedEnvValue('FCM_MEASUREMENT_ID'),
      };

export const handleOnMessageReceived = async (data) => {
  const action = parseJSON(data?.data?.params)?.code;

  switch (action) {
    case 'call_detection': {
      const state = getState();
      const { activityId } = getPhoneCallDetails(state);
      store.dispatch(
        renderModule({
          id: Modules.REVYRE_DETAILS_360,
          props: {
            domainType: 'activity',
            entityId: activityId,
          },
        }),
      );
      const message = data?.notification?.body;
      store.dispatch(
        setNotification({
          message,
          variant: 'info',
          messageId: String(Date.now()),
        }),
      );
      break;
    }

    default:
      break;
  }
};
